/** SLA 残り時間を 1 分ごとに再計算するためのティック（改善 D）。
 *  サーバ時刻との差分（api.ts で初回同期）を含んだ「いまのサーバ時刻」を返す。 */

import { useEffect, useState } from "react";
import { serverNow } from "../api.ts";

export function useMinuteTick(): number {
  const [now, setNow] = useState(() => serverNow());
  useEffect(() => {
    const id = window.setInterval(() => setNow(serverNow()), 60 * 1000);
    return () => window.clearInterval(id);
  }, []);
  return now;
}
